import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_URL } from '../../utils/constants';

const PageSEO = ({
  title,
  description,
  canonical,
  ogImage = `${SITE_URL}/og-image.png`,
  noIndex = false,
}) => {
  const fullCanonical = canonical || SITE_URL + '/';

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullCanonical} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default PageSEO;
